<template>
  <div class="platform-parameter">
    <div class="setting-box">
      <div class="title">
        平台费与固定成本<span
          class="show-edit"
          @click="toEdit('platformFeeRate')"
          >管理</span
        >
      </div>
      <div class="rule">
        <span>{{ settingsData.ruleType }}</span>
        <span
          >可分成业绩=应收业绩-返佣支出-平台费-交易成本，其中交易成本=固定成本+自定义成本</span
        >
      </div>
      <el-table :data="settingsData.items" border>
        <el-table-column prop="type" label="交易性质" min-width="200">
        </el-table-column>
        <el-table-column label="平台费比例" min-width="200" prop="rate">
        </el-table-column>
        <el-table-column prop="name" label="成本名称" min-width="200">
        </el-table-column>
        <el-table-column
          prop="amount"
          label="成本金额（元/单）"
          min-width="200"
        >
        </el-table-column>

        <template slot="empty">
          <div class="loading-box" v-if="isLoading">
            <img
              src="../../../../assets/image/loading.png"
              alt="loading"
              class="loading-ico"
            />
            数据加载中...
          </div>
          <div
            class="empty-box"
            v-if="
              !isLoading && settingsData.items && settingsData.items.length != 0
            "
          >
            列表为空
          </div>
        </template>
      </el-table>
    </div>
    <div class="setting-box">
      <div class="title">
        业绩分成设置
        <span
          class="show-edit"
          @click="toEdit('sumOfDistributionRate')"
          v-if="showEdit != 'sumOfDistributionRate'"
          >管理</span
        >
        <span v-else>
          <el-button type="primary" @click="submitSum">确定</el-button>
          <el-button @click="showEdit = false">取消</el-button>
        </span>
      </div>
      <el-row class="sum-rate">
        <el-col :span="8">业绩分成之和</el-col>
        <el-col :span="16"
          ><span class="sum-val" v-if="showEdit != 'sumOfDistributionRate'"
            >{{ sumOfDistributionRate.value }}%</span
          >
          <span v-else>
            <el-input
              @change="numberChange"
              v-model="sumOfDistributionRate.value"
            ></el-input
          ></span>
          要求业绩分成时，所有分成方案比例之和的上限</el-col
        >
      </el-row>
    </div>
    <div class="setting-box">
      <div class="title">结佣批次设置</div>
      <el-table :data="CommissionWay.value" border>
        <el-table-column
          prop="transactionType"
          label="交易性质"
          min-width="200"
        >
        </el-table-column>
        <el-table-column prop="commissionType" label="结佣类型" min-width="200">
        </el-table-column>
        <el-table-column label="结佣条件" min-width="200">
          <template slot-scope="scope">
            <span v-if="scope.row.commissionType == '一次结佣'"
              >签约且收齐佣金</span
            >
            <span v-else-if="scope.row.commissionType == '多次结佣'">
              <span v-for="(item, index) in scope.row.items" :key="index">
                签约结第{{ index + 1 }}次<span
                  v-if="index < scope.row.items.length - 1"
                  >;</span
                >
              </span>
            </span>
            <span v-else-if="scope.row.commissionType == '按实收结佣'"
              >佣金大于0(包括已收齐)</span
            >
          </template>
        </el-table-column>
        <el-table-column label="操作" width="60" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="edit(scope.row, scope.$index)"
              >修改</el-button
            >
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="loading-box" v-if="isLoading">
            <img
              src="../../../../assets/image/loading.png"
              alt="loading"
              class="loading-ico"
            />
            数据加载中...
          </div>
          <div
            class="empty-box"
            v-if="
              !isLoading &&
              CommissionWay.value &&
              CommissionWay.value.length != 0
            "
          >
            列表为空
          </div>
        </template>
      </el-table>
    </div>
    <div class="setting-box">
      <div class="title">
        其他交易结佣设置
        <span
          class="show-edit"
          @click="toEdit('OtherSettleCommission')"
          v-if="showEdit != 'OtherSettleCommission'"
          >管理</span
        >
        <span v-else>
          <el-button @click="showEdit = false">取消</el-button>
        </span>
      </div>
      <el-row class="other-settle-commission">
        <el-col :span="8">{{ OtherSettleCommission.displayName }}</el-col>
        <el-col :span="16">
          <el-switch
            v-model="OtherSettleCommission.value"
            @change="submitOtherSettleCommission"
            :disabled="showEdit != 'OtherSettleCommission'"
          ></el-switch>
          若开启则主交易收齐结佣后，关联交易才能结佣；若关闭则关联交易签约且收齐即可结佣</el-col
        >
      </el-row>
    </div>
    <div class="setting-box last">
      <div class="title">
        其他设置
        <span
          class="show-edit"
          @click="toEdit('OtherAchievement')"
          v-if="showEdit != 'OtherAchievement'"
          >管理</span
        >
        <span v-else>
          <el-button type="primary" @click="submitOther">确定</el-button>
          <el-button @click="showEdit = false">取消</el-button>
        </span>
      </div>
      <el-row class="sum-rate">
        <el-col :span="8">{{ OtherAchievement.displayName }}</el-col>
        <el-col :span="16"
          ><span class="sum-val" v-if="showEdit != 'OtherAchievement'">{{
            OtherAchievement.value
          }}</span>
          <span v-else>
            <el-select v-model="OtherAchievement.value" placeholder="请选择">
              <el-option
                v-for="item in transactionCollectionDateStandardTypeDic"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </span>
          取所有佣金收款单中收款日期/收款审批通过日期/到账日期最晚的那个日期作为收齐日期</el-col
        >
      </el-row>
    </div>
    <el-drawer
      title="平台费与固定成本"
      :with-header="false"
      :visible.sync="isDrawerShow"
      direction="rtl"
    >
      <div class="drawer-title">
        平台费与固定成本
        <span @click="isDrawerShow = false">
          <svg-icon icon-class="close-ico" />
        </span>
      </div>
      <el-form
        label-position="left"
        label-width="8rem"
        :model="settingsData"
        :rules="rules"
      >
        <el-form-item label="平台费计算规则" prop="ruleType" class="pay-type rule-type">
          <el-select v-model="settingsData.ruleType" placeholder="请选择">
            <el-option
              v-for="item in ruleTypeDic"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-table
        :data="settingsData.items"
        border
        class="setting-table"
        row-key="index"
      >
        <el-table-column label="交易性质" :resizable="false">
          <template slot-scope="scope">
            <el-select v-model="scope.row.type" placeholder="请选择">
              <el-option
                v-for="item in transactionTypeDic"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="平台费比例" :resizable="false">
          <template slot-scope="scope">
            <el-input v-model="scope.row.rate" class="small-input" v-enter-number @input="changeNum(scope.$index,'rate',scope.row.rate)"></el-input>%
          </template>
        </el-table-column>
        <el-table-column label="成本名称" :resizable="false">
          <template slot-scope="scope">
            <el-input v-model="scope.row.name" class="small-input"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="成本金额" :resizable="false">
          <template slot-scope="scope">
            <el-input v-model="scope.row.amount" class="small-input" v-enter-number @input="changeNum(scope.$index,'amount',scope.row.amount)"></el-input
            >元/单
          </template>
        </el-table-column>
        <el-table-column label="操作" width="135" :resizable="false">
          <template slot-scope="scope">
            <el-button
              @click.native.prevent="deleteSetting(scope.$index)"
              type="text"
              class="del-btn"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="add-setting" @click="addSetting">
        <i class="el-icon-plus"></i>添加参数
      </div>
      <span class="dialog-footer">
        <div>
          <el-button @click="isDrawerShow = false">取 消</el-button>
          <el-button type="primary" @click.stop="submitEditSetting"
            >确 定</el-button
          >
        </div>
      </span>
    </el-drawer>
    <el-dialog
      title="结佣批次设置"
      :visible.sync="isShowCommissionWay"
      class="setting-dialog"
    >
      <el-form
        label-position="left"
        label-width="8rem"
        :model="commissionWayForm"
        :rules="rules"
      >
        <el-form-item label="结佣方式" prop="ruleType" class="pay-type">
          <el-select
            v-model="commissionWayForm.commissionType"
            placeholder="请选择"
            @change="changeCommissionType"
          >
            <el-option
              v-for="item in transactionCommissionTypeDic"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <div
          class="commission-item"
          v-for="(item, index) in commissionWayForm.items"
          :key="index"
          :class="{ last: index == commissionWayForm.items.length - 1 }"
        >
          <div
            class="commission-tit"
            v-if="
              commissionWayForm.commissionType == '多次结佣' ||
              commissionWayForm.commissionType == '按实收结佣'
            "
          >
            第{{ index + 1 }}次结佣<span class="delete-way" v-if="index==2" @click="deleteWay">删除</span>
          </div>
          <!-- <el-form-item label="流程条件" prop="deductFlag" class="pay-type">
            <el-checkbox v-model="item.deductFlag">签约且审核通过</el-checkbox>
          </el-form-item> -->
          <el-form-item label="业绩条件" prop="ruleType" class="pay-type">
            <el-checkbox :label="true" :disabled="true" v-model="checked"
              >申报业绩且审批通过</el-checkbox
            >
            <el-checkbox :label="true" :disabled="true" v-model="checked"
              >分成方案会签通过</el-checkbox
            >
          </el-form-item>
          <el-form-item
            label="收佣条件"
            prop="ruleType"
            class="pay-type"
            v-if="commissionWayForm.commissionType == '一次结佣'"
          >
            <el-checkbox :label="true" :disabled="true" v-model="checked"
              >佣金已收集齐</el-checkbox
            >
          </el-form-item>
          <el-form-item
            label="收佣条件"
            prop="ruleType"
            class="pay-type"
            v-if="
              commissionWayForm.commissionType == '多次结佣' &&
              index < commissionWayForm.items.length - 1
            "
          >
            实收佣金达到应收的<el-input
              class="receivable-rate"
              v-model="item.receivableRate"
              v-enter-number
              @input="changeNumOthen(index,'receivableRate',item.receivableRate)"
            ></el-input
            >%
          </el-form-item>
          <el-form-item
            label="收佣条件"
            prop="ruleType"
            class="pay-type"
            v-if="
              commissionWayForm.commissionType == '多次结佣' &&
              index == commissionWayForm.items.length - 1
            "
          >
            <el-checkbox :label="true" :disabled="true" v-model="checked"
              >佣金已收集齐</el-checkbox
            >
          </el-form-item>
          <el-form-item
            label="计提金额"
            prop="ruleType"
            class="pay-type auto-height"
            v-if="
              commissionWayForm.commissionType == '多次结佣' &&
              index < commissionWayForm.items.length - 1
            "
          >
            <div class="deduct-flag">
              是否先扣除平台费和成本
              <el-radio-group v-model="item.deductFlag">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </div>
            <div class="received-rate">
              <span v-if="item.deductFlag">(已收佣金-平台费-成本)</span>
              <span v-else>(已收佣金)</span>*
              <el-input
                class="receivable-rate"
                v-model="item.receivedRate"                
                v-enter-number
                @input="changeNumOthen(index,'receivedRate',item.receivedRate)"
              ></el-input>
              %(若计算结果>可分成业绩，则使用“可分成业绩*n%”)
              -已结算的计提金额总和
            </div>
          </el-form-item>
          <el-form-item
            label="计提金额"
            prop="ruleType"
            class="pay-type auto-height"
            v-if="
              commissionWayForm.commissionType == '多次结佣' &&
              index == commissionWayForm.items.length - 1
            "
          >
            <div class="received-rate">
              可分成业绩-已结算的计提金额总和
              <el-tooltip
                class="item"
                effect="dark"
                content="可分成业绩 = 应收业绩-返佣-成本-平台费"
                placement="top"
              >
                <i class="el-icon-warning-outline"></i>
              </el-tooltip>
            </div>
          </el-form-item>

          <!-- 按实收结佣 -->
          <el-form-item
            label="收佣条件"
            prop="ruleType"
            class="pay-type"
            v-if="
              commissionWayForm.commissionType == '按实收结佣' &&
              index < commissionWayForm.items.length - 1
            "
          >
            <el-checkbox :label="true" :disabled="true" v-model="checked"
              >佣金大于0（包括已收齐）</el-checkbox
            >
          </el-form-item>
          <el-form-item
            label="收佣条件"
            prop="ruleType"
            class="pay-type"
            v-if="
              commissionWayForm.commissionType == '按实收结佣' &&
              index == commissionWayForm.items.length - 1
            "
          >
            <el-checkbox :label="true" :disabled="true" v-model="checked"
              >佣金已收集齐</el-checkbox
            >
          </el-form-item>
          <el-form-item
            label="计提金额"
            prop="ruleType"
            class="pay-type auto-height"
            v-if="
              commissionWayForm.commissionType == '按实收结佣' &&
              index < commissionWayForm.items.length - 1
            "
          >
            <div class="deduct-flag">
              是否先扣除平台费和成本
              <el-radio-group v-model="item.deductFlag">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </div>
            <div class="received-rate">
              <span v-if="item.deductFlag">(已收佣金-平台费-成本)</span>
              <span v-else>(已收佣金)</span>*
              <el-input
                class="receivable-rate"
                v-model="item.receivedRate"
                v-enter-number
                @input="changeNumOthen(index,'receivedRate',item.receivedRate)"
              ></el-input>
              %(若计算结果>可分成业绩，则使用“可分成业绩*n%”)
              -已结算的计提金额总和
            </div>
          </el-form-item>
          <el-form-item
            label="计提金额"
            prop="ruleType"
            class="pay-type auto-height"
            v-if="
              commissionWayForm.commissionType == '按实收结佣' &&
              index == commissionWayForm.items.length - 1
            "
          >
            <div class="received-rate">
              可分成业绩-已结算的计提金额总和
              <el-tooltip
                class="item"
                effect="dark"
                content="可分成业绩 = 应收业绩-返佣-成本-平台费"
                placement="top"
              >
                <i class="el-icon-warning-outline"></i>
              </el-tooltip>
            </div>
          </el-form-item>
          
        </div>
        
        <div
          class="add-way"
          v-if="commissionWayForm.items&&
            commissionWayForm.items.length != 3 &&
            commissionWayForm.commissionType == '多次结佣'
          "
          @click="addWay"
        >
          <i class="el-icon-plus"></i>新增结佣批次
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowCommissionWay = false">取消</el-button>
        <el-button type="primary" @click="submitCommissionWay">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getTransactionSettings,
  updateTransactionSettings,
  updateTransactionCommissionWaySettings,
} from "@/http/api/system";
import { deepCopy } from "@/utils/deepCopy";
import Sortable from "sortablejs";

export default {
  props: {
    isEdit: { type: Boolean },
  },
  data() {
    return {
      customTitle: "",
      settingName: "",
      showEdit: false,
      isLoading: true,
      isAddCustom: false,
      customName: "",
      checked: true,
      customForm: {
        option: "",
        error: false,
      },
      permissions: this.$store.getters.permissions,
      settingsData: {},
      sumOfDistributionRate: {},
      OtherSettleCommission: {},
      OtherAchievement: {},
      CommissionWay: {},
      isDrawerShow: false,
      commissionWayIndex: 0,
      commissionWayForm: {},
      isShowCommissionWay: false,
      ruleTypeDic: this.$store.getters.enumMetadata
        .TransactionPlatformFeeRateRuleType,
      transactionTypeDic: this.$store.getters.enumMetadata.TransactionType,
      transactionCollectionDateStandardTypeDic: this.$store.getters.enumMetadata
        .TransactionCollectionDateStandardType,
      transactionCommissionTypeDic: this.$store.getters.enumMetadata
        .TransactionSettingCommissionType,
      settingsCustomData: [
        {
          option: "",
          error: false,
        },
      ],
      rules: {
        payType: [
          { required: true, message: "请选择付款性质", trigger: "change" },
        ],
      },
      index: 0,
      customIndex: 0,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    changeNum(index,val,num){
      if(num[0]==0&&num.length>1){
        num = num.slice(1)
      }//console.log(val,'q231');
      this.settingsData.items[index][val]=num==""?0:num
      if(val=='rate'){
        this.settingsData.items[index][val]=num>100?100:num
      }
    },
    changeNumOthen(index,val,num){
      if(num[0]==0&&num.length>1){
        num = num.slice(1)
      }//console.log(val,num,'q231');
      this.commissionWayForm.items[index][val]=num==""?0:num
      this.commissionWayForm.items[index][val]=num>100?100:num
      
    },
    deleteWay(){
      this.commissionWayForm.items.splice(2,1)
    },
    addWay() {
      this.commissionWayForm.items.push({
        deductFlag: false,
        isCollectedAll: true,
        receivableRate: 0,
        receivedRate: 0,
        sort: 1,
      });
    },
    changeCommissionType() {
      if (this.commissionWayForm.commissionType == "一次结佣") {
        this.commissionWayForm.items = [
          {
            deductFlag: false,
            isCollectedAll: true,
            receivableRate: 0,
            receivedRate: 0,
            sort: 1,
          },
        ];
      } else if (this.commissionWayForm.commissionType == "多次结佣") {
        this.commissionWayForm.items = [
          {
            deductFlag: false,
            isCollectedAll: true,
            receivableRate: 0,
            receivedRate: 0,
            sort: 1,
          },
          {
            deductFlag: false,
            isCollectedAll: true,
            receivableRate: 0,
            receivedRate: 0,
            sort: 2,
          },
        ];
      } else if (this.commissionWayForm.commissionType == "按实收结佣") {
        this.commissionWayForm.items = [
          {
            deductFlag: false,
            isCollectedAll: true,
            receivableRate: 0,
            receivedRate: 0,
            sort: 1,
          },
          {
            deductFlag: false,
            isCollectedAll: true,
            receivableRate: 0,
            receivedRate: 0,
            sort: 2,
          },
        ];
      }
    },
    submitCommissionWay() {
      Object.keys(this.transactionTypeDic).forEach((item) => {
        if (
          this.transactionTypeDic[item] ==
          this.commissionWayForm.transactionType
        ) {
          this.commissionWayForm.transactionType = item;
        }
      });
      Object.keys(this.transactionCommissionTypeDic).forEach((item) => {
        if (
          this.transactionCommissionTypeDic[item] ==
          this.commissionWayForm.commissionType
        ) {
          this.commissionWayForm.commissionType = item;
        }
      });
      updateTransactionCommissionWaySettings(
        this.$store.getters.generateUpdateSettingsParams,
        this.commissionWayForm
      ).then((res) => {
        if (res) {
          this.$message.success({
            message: `修改成功`,
            showClose: true,
          });
        }
        this.getSettingData();
        this.isShowCommissionWay = false        
        this.showEdit = false;
      });
    },
    numberChange() {
      var value = this.sumOfDistributionRate.value;
      var min = 1;
      var max = 1000;
      if (parseInt(value) < min) {
        this.sumOfDistributionRate.value = 0;
      } else if (parseInt(value) > max) {
        this.sumOfDistributionRate.value = 100;
      } else if (value < max && value > min) {
        this.sumOfDistributionRate.value = this.sumOfDistributionRate.value;
      } else {
        this.sumOfDistributionRate.value = 0;
      }
    },
    submitOther() {
      let data = {
        settings: [
          {
            name: this.OtherAchievement.name,
            value: this.OtherAchievement.value,
            isCollection: false,
            forceToSet: false,
          },
        ],
      };
      updateTransactionSettings(
        this.$store.getters.generateUpdateSettingsParams,
        data
      ).then((res) => {
        if (res) {
          this.$message.success({
            message: `修改成功`,
            showClose: true,
          });
        }
        this.getSettingData();
        this.showEdit = false;
      });
    },
    submitOtherSettleCommission() {
      let data = {
        settings: [
          {
            name: this.OtherSettleCommission.name,
            value: this.OtherSettleCommission.value,
            isCollection: false,
            forceToSet: false,
          },
        ],
      };
      updateTransactionSettings(
        this.$store.getters.generateUpdateSettingsParams,
        data
      ).then((res) => {
        if (res) {
          this.$message.success({
            message: `修改成功`,
            showClose: true,
          });
        }
        this.getSettingData();
        this.showEdit = false;
      });
    },
    submitSum() {
      let data = {
        settings: [
          {
            name: this.sumOfDistributionRate.name,
            value: this.sumOfDistributionRate.value,
            isCollection: false,
            forceToSet: false,
          },
        ],
      };
      updateTransactionSettings(
        this.$store.getters.generateUpdateSettingsParams,
        data
      ).then((res) => {
        if (res) {
          this.$message.success({
            message: `修改成功`,
            showClose: true,
          });
        }
        this.getSettingData();
        this.showEdit = false;
      });
    },
    toEdit(val) {
      if (val == "platformFeeRate") {
        this.isDrawerShow = true;
      } else if (val == "sumOfDistributionRate") {
        this.showEdit = "sumOfDistributionRate";
      } else if (val == "OtherSettleCommission") {
        this.showEdit = "OtherSettleCommission";
      } else if (val == "OtherAchievement") {
        this.showEdit = "OtherAchievement";
      }
    },
    addSetting() {
      this.settingsData.items.push({
        amount: 0,
        name: "无",
        rate: 0,
        type: "",
      });
    },
    init() {
      this.getSettingData();
      // 阻止默认行为
      document.body.ondrop = function (event) {
        event.preventDefault();
        event.stopPropagation();
      };
    },

    // 删除
    deleteSetting(i) {
      this.settingData.splice(i, 1);
      //console.log(this.settingData, "this.settingData");
    },
    // 修改
    edit(v, index) {
      if (this.permissions["System.TransactionSettings.Update"]) {
        this.commissionWayIndex = index;
        this.commissionWayForm = v;
        this.isShowCommissionWay = true;
        //console.log(v, "commissionWayForm");
      } else {
        this.$message.warning({
          message: `您暂无更新交易设置权限`,
          showClose: true,
        });
      }
    },
    // 获取基础字段
    getSettingData() {
      this.isLoading = true;
      this.settingsData = {};
      let query = [
        { type: "PlatformFeeRate" }, //平台费与固定成本
        { type: "CommissionRateOfRent" }, //业绩分成比例之和
        { type: "OtherSettleCommission" }, //附件类参数
        { type: "OtherAchievement" }, //其它设置
        { type: "CommissionWay" }, //结佣方式、结佣批次设置
      ];
      getTransactionSettings(query[0])
        .then((res) => {
          this.settingsData = res.result[0].value;
          this.isLoading = false;

          this.settingName = res.result[0].name;
        })
        .catch((err) => {
          this.isLoading = false;
        });

      getTransactionSettings(query[1])
        .then((res) => {
          this.sumOfDistributionRate = res.result[0];
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
        });
      getTransactionSettings(query[2])
        .then((res) => {
          res.result.map((item) => {
            this.OtherSettleCommission = res.result[0];
          });
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
        });
      getTransactionSettings(query[3])
        .then((res) => {
          res.result.map((item) => {
            this.OtherAchievement = res.result[0];
          });
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
        });
      getTransactionSettings(query[4])
        .then((res) => {
          res.result.map((item) => {
            this.CommissionWay = res.result[0];
          });
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
        });
    },

    // 提交修改设置项
    submitEditSetting() {
      let data = {
        settings: [
          {
            name: this.settingName,
            value: JSON.stringify(this.settingsData),
            isCollection: false,
            forceToSet: false,
          },
        ],
      };
      updateTransactionSettings(
        this.$store.getters.generateUpdateSettingsParams,
        data
      ).then((res) => {
        if (res) {
          this.$message.success({
            message: `修改成功`,
            showClose: true,
          });
        }
        this.getSettingData();
        this.isDrawerShow = false
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/mixin.scss";
.platform-parameter {
  .setting-box {
    margin-bottom: 20px;
    padding-bottom: 20px;
    background: #fff;
    .title {
      @include flex(row, center);
      justify-content: space-between;
      margin-bottom: 20px;
      padding: 20px;
      border-bottom: 1px solid #e0e0e0;
      font-size: 15px;
      .show-edit {
        cursor: pointer;
        color: $--color-primary;
      }
    }
    .rule {
      @include flex(row, center);
      justify-content: space-between;
      padding: 0 20px;
      color: #666;
    }
    .sum-rate {
      padding: 0 20px;
      .sum-val {
        margin-right: 70px;
      }
      .el-input {
        margin-right: 50px;
        width: 100px;
      }
    }
    .other-settle-commission {
      padding: 0 20px;
      .el-switch {
        margin-right: 100px;
      }
    }
    .custom {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .title-tip {
      margin-left: 50px;
      font-size: 14px;
      color: #666;
    }

    ::v-deep .el-table {
      margin: 20px;
      margin-bottom: 30px;
      width: calc(100% - 45px);

      .el-table__header {
        th {
          background-color: #f2f2f2;
        }

        th {
          padding: 7px 0;
        }
      }

      td {
        padding: 7px 0;
      }

      .el-table__row {
        .cell {
          .setting-value {
            color: #000;
          }

          .setting-default {
            color: #888;
          }
        }
      }
    }
    .custom-table {
      margin-bottom: 0;
      min-width: 500px;

      .el-button.is-disabled {
        border-color: transparent;
        background-color: transparent;
      }
    }
  }
  .last {
    margin-bottom: 0px;
  }

  .setting-dialog {
    ::v-deep .el-dialog__body {
      overflow-y: auto;
      margin-right: 0;
      padding-right: 20px;
      width: 790px;
      max-height: calc(100vh - 250px);
      .commission-item {
        padding-bottom: 20px;
        border-bottom: 1px solid #dfdfdf;
        .commission-tit {
          padding: 10px 0;
          font-size: 18px;
        }
        .receivable-rate {
          margin: 0 5px;
          width: 100px;
        }
      }
      .last {
        border-bottom: 0;
      }
      .add-way{
        color: $--color-primary;
        cursor: pointer;
        i{
          margin-right: 5px;
        }
      }
      .delete-way{
        cursor: pointer;
        margin-left: 10px;
        font-size: 14px;
        font-weight: 500;
        color: $--color-primary;
      }
      .el-input {
        width: 180px;
      }
    }

    .dialog-footer {
      .add-setting {
        color: $--color-primary;
        cursor: pointer;

        i {
          margin-right: 2px;
        }

        .required-item {
          margin-left: 4px;
          color: #f56c6c;
        }
      }
    }
  }
  ::v-deep .el-drawer {
    .drawer-title {
      width: 900px;
      border: 0;
    }
    .pay-type {
      padding-bottom: 20px;
      border-bottom: 1px dashed #387cef;
      width: 100%;
      .el-input {
        width: 200px;
      }
    }
    .rule-type{
      .el-input{
        width: 350px;
      }      
    }
    .small-input {
      margin-right: 10px;
      width: 100px;
    }
    .add-setting {
      padding: 10px 0;
      border: 1px solid #dfdfdf;
      border-top: 0;
      width: 100%;
      text-align: center;
      color: $--color-primary;
      cursor: pointer;

      i {
        margin-right: 2px;
      }

      .required-item {
        margin-left: 4px;
        color: #f56c6c;
      }
    }
    .dialog-footer {
      position: absolute;
      bottom: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
}
</style>